import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const ROLE_PATH = {
  EN: '/dashboard/enseignant',
  CE: '/dashboard/chef',
  CP: '/dashboard/conseiller',
  DA: '/dashboard/directeur',
  SC: '/admin',
};

export default function DashboardRedirect() {
  const { user } = useAuth();
  const target = ROLE_PATH[user?.role_code] || '/dashboard/enseignant';
  return <Navigate to={target} replace />;
}
